<div
  class="movebank-forwarder-chips-cell"
  (click)="onClickShowMore()"
  [ngClass]="{ open: showMore }"
  [class.movebank-forwarder-chips-cell-compact-mode]="isCompactModeActivated()"
>
  <div class="example-chip-list">
    <mat-chip-grid #chipList aria-label="Movebank forwarder">
      <div class="display-block" [ngClass]="{ open: showMore }">
        @for (item of selectedMovebankForwarders(); let i = $index; track item.movebankUsername) {
          @if (showMore || i < 1) {
            <mat-chip-row
              class="example-chip-list__chip"
              [matTooltip]="item.movebankUsername + ' (' + item.inventaUsername + ')'"
              (removed)="onRemoveRule(item)"
            >
              {{
                (item.movebankUsername + item.inventaUsername).length > 16 && !showMore
                  ? (item.movebankUsername + ' (' + item.inventaUsername + ')' | slice: 0 : 16) +
                    '...'
                  : item.movebankUsername + ' (' + item.inventaUsername + ')'
              }}
              @if (showMore && !readonly()) {
                <button matChipRemove>
                  <mat-icon class="example-chip-list__delete">cancel</mat-icon>
                </button>
              }
            </mat-chip-row>
          }
        }

        @if (!showMore && selectedMovebankForwarders()?.length > 1) {
          <mat-chip-row class="example-chip-list__chip">
            +{{ selectedMovebankForwarders()?.length - 1 }}
          </mat-chip-row>
        }
      </div>
      <div class="example-chip-list__input-container">
        <input
          class="example-chip-list__input"
          [ngClass]="{ hidden: !showMore || readonly() }"
          #input
          placeholder="Add inventa username"
          [formControl]="formControl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
        />
        @if (showMore && !readonly()) {
          <button
            mat-icon-button
            (click)="addButton()"
            [disabled]="!formControl.value || formControl.invalid"
            matTooltip="Add"
          >
            <mat-icon>add_box</mat-icon>
          </button>
        }
      </div>
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (address of filtered(); track address.movebankUsername) {
        <mat-option [value]="address">
          {{ address.movebankUsername }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>
  @if (showMore) {
    <button
      class="movebank-forwarder-chips-cell__show-less"
      mat-icon-button
      matTooltip="Close"
      (click)="onClickShowLess($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
